/**
 * LYTICK Icon Paths
 *
 * Single source of truth for all LYTICK branding assets.
 * All icons are served from the lytick-icons folder in public.
 */

export const LYTICK_ICONS = {
  // Hero logos (main branding)
  hero: {
    light: "/lytick-icons/hero-black.svg",
    dark: "/lytick-icons/hero-white.svg",
  },

  // Mobile logos
  mobile: {
    light: "/lytick-icons/mobile-black.svg",
    dark: "/lytick-icons/mobile-white.svg",
  },

  // PNG fallbacks (if SVG is not supported)
  heroPng: {
    light: "/lytick-icons/black-hero.png",
    dark: "/lytick-icons/white-hero.png",
  },

  mobilePng: {
    light: "/lytick-icons/black-mobile.png",
    dark: "/lytick-icons/white-mobile.png",
  },

  // Favicons
  favicon: "/lytick-icons/favicon_io/favicon.ico",
  favicon16: "/lytick-icons/favicon_io/favicon-16x16.png",
  favicon32: "/lytick-icons/favicon_io/favicon-32x32.png",
  appleTouch: "/lytick-icons/favicon_io/apple-touch-icon.png",
  android192: "/lytick-icons/favicon_io/android-chrome-192x192.png",
  android512: "/lytick-icons/favicon_io/android-chrome-512x512.png",
} as const;

export type IconTheme = "light" | "dark";

/**
 * Get the hero icon URL based on the current theme
 */
export function getHeroIconUrl(theme: IconTheme = "dark"): string {
  return LYTICK_ICONS.hero[theme];
}

/**
 * Get the mobile icon URL based on the current theme
 */
export function getMobileIconUrl(theme: IconTheme = "dark"): string {
  return LYTICK_ICONS.mobile[theme];
}
